import { ValidatorFn, AbstractControl, ValidationErrors } from "@angular/forms";

export const emailValidator = (control: any)=> {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (control.value && !emailPattern.test(control.value)) {
      return { emailInvalid: true };
    }
    return null;
}

export const noWhitespace: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  let isWhitespace = (control.value || '').trim().length === 0;
  let isValid = !isWhitespace;
  return isValid ? null : { whitespace: true }
}